import { render, staticRenderFns } from "./BtnAddBack.vue?vue&type=template&id=63375738"
import script from "./BtnAddBack.vue?vue&type=script&lang=js"
export * from "./BtnAddBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports